import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Group,
  Paper,
  rem,
  Text,
  Title,
} from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import BeneficiaryAccounts from "../../components/BeneficiaryAccounts";
import { get } from "lodash";
import { PreviewSavingsResponse } from "@/dto/savings/Savings";
import { beText } from "@/utils/beText";

interface Props {
  onSubmit?: () => void;
  onChangeSourceLinkId?: (id: string, availableBalance: number) => void;
  dataWithdraw?: PreviewSavingsResponse;
  isLoadingStepOne?: boolean;
}

const DepositSettlementStepOne: React.FC<Props> = ({
  onSubmit,
  onChangeSourceLinkId,
  dataWithdraw,
  isLoadingStepOne,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  if (!dataWithdraw) return null;
  const dataSources = get(dataWithdraw, "beneficiaryAccounts", []);
  const infoSavings = get(dataWithdraw, "savingsAccountInfo", []);
  const transInfo = get(dataWithdraw, "transactionInfo", []);
  return (
    <Box>
      <Grid gutter="lg">
        <Grid.Col span={12} md={7}>
          <Paper bg="white" p={20} radius={10}>
            {/* THÔNG TIN KHOẢN GỬI */}
            <Text fw={600} mb="sm">
              {t("DEPOSIT_INFORMATION")}
            </Text>

            <Grid gutter="md" align="flex-start">
              {/* Hàng 1 - Tên doanh nghiệp / Địa chỉ */}
              {infoSavings &&
                infoSavings.map((item) => (
                  <Grid.Col span={6} md={6} key={item.key}>
                    <Flex>
                      <Text fz="sm" c="dimmed" w="50%">
                        {beText(item.name)}
                      </Text>
                      <Text fz="sm" fw={500}>
                        {beText(item.value)}
                      </Text>
                    </Flex>
                  </Grid.Col>
                ))}
            </Grid>

            <Divider my="sm" variant="dashed" />

            {/* THÔNG TIN TẤT TOÁN */}
            <Text fw={600} my="20px">
              {t("SETTLEMENT_INFORMATION")}
            </Text>

            <Grid gutter="md" align="flex-start">
              {transInfo &&
                transInfo.map((item) => (
                  <Grid.Col span={12} md={6} key={item.key}>
                    <Flex>
                      <Text fz="sm" c="dimmed" w="50%">
                        {beText(item.name)}
                      </Text>
                      <Text fz="sm" fw={500}>
                        {beText(item.value)}
                      </Text>
                    </Flex>
                  </Grid.Col>
                ))}
            </Grid>
          </Paper>
          <Paper bg="white" p={20} radius={10} mt={20}>
            <Text fw={600} my="20px">
              {t("BENEFICIARY_ACCOUNT")}
            </Text>
            <BeneficiaryAccounts
              sourceAccount={dataSources}
              onChangeSourceLinkId={onChangeSourceLinkId}
            />
          </Paper>
        </Grid.Col>
      </Grid>
      <Group position="center" mt={rem(20)}>
        <Box
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            width: "calc(100% - var(--mantine-navbar-width, 0px))",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            boxShadow: "0px 5px 15px 0px #00000026",
            height: "76px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <Flex>
            <Title fz={14}>{t("TOTAL_AMOUNT_RECEIVED_COLON")} </Title>
            <Title fz={14} c="#0171BB">
              102.250.000 VND
            </Title>
          </Flex>
          <Flex gap={10}>
            <Button
              variant="default"
              sx={() => ({
                width: "160px",
                color: "black",
                borderRadius: "8px",
                padding: "8px 10px",
                cursor: "pointer",
                background: "#F4F4F6",
                fontWeight: 400,
              })}
              onClick={() => navigate(-1)}
            >
              {t("DISMISS")}
            </Button>
            <Button
              type="submit"
              onClick={onSubmit}
              loading={isLoadingStepOne}
              sx={() => ({
                width: "160px",
                backgroundColor: "#2A81D0",
                color: "white",
                borderRadius: "8px",
                padding: "8px 10px",
                cursor: "pointer",
                fontWeight: 400,
              })}
            >
              {t("NEXT")}
            </Button>
          </Flex>
        </Box>
      </Group>
    </Box>
  );
};

export default DepositSettlementStepOne;
